// Teardown for SimpleroManagers (see dom_ready.js), split out so it can be unit-tested without a
// DOM.
//
// Turbolinks caches the outgoing <body> as-is, jQuery data included, and restores it on
// back/forward. A manager torn down here has its data key removed, so the restore's page:change
// sets it up again from scratch. That means a manager's destroy() must undo everything its
// constructor did.

// Classic Turbolinks passes the nodes it's about to replace as the event's data. The Turbo shim
// (entrypoints/turbo.js) passes `{}`, and always swaps the whole body.
export const outgoingNodesFrom = (eventData, body) =>
  Array.isArray(eventData) ? eventData : [body]

// Destroys every registered manager whose element is leaving the page, and removes it from
// `managers`. On a full-body swap that includes managers on detached elements (e.g. set up by an
// AJAX response that landed after the page was cached), since nothing is coming back for them.
// Managers inside [data-turbolinks-permanent] nodes are carried over to the next page, so they
// stay. Nothing uses partial replacements today; if one appends/prepends to a node, managers in it
// are torn down and then set up again by page:change's `$('body').changed()`.
export const tearDownManagers = (managers, outgoingNodes, body) => {
  const fullBody = outgoingNodes.includes(body)

  for (const manager of managers) {
    const element = manager.elm[0]
    if (element.closest('[data-turbolinks-permanent]')) continue

    const leaving =
      outgoingNodes.some((node) => node.contains(element)) ||
      (fullBody && !element.isConnected)
    if (!leaving) continue

    managers.delete(manager)
    try {
      manager.destroy()
    } catch (error) {
      window.logerror(error, {
        message: 'error destroying manager',
        manager: manager.manager_name,
      })
    }
    manager.elm.removeData(`simpleroManager${manager.manager_name}`)
  }
}
